/**
 * Texto dos artigos com **negrito** e [links](/caminho)
 *
 * Links internos usam o roteador (sem recarregar a página); externos abrem
 * em nova aba. Não interpreta HTML: o conteúdo é sempre texto.
 */

import { Fragment, ReactNode } from 'react';
import { Link } from 'react-router-dom';

const TOKEN = /(\*\*[^*]+\*\*|\[[^\]]+\]\([^)]+\))/g;

export function RichText({ text }: { text: string }) {
  const parts = text.split(TOKEN).filter(Boolean);
  const nodes: ReactNode[] = parts.map((part, i) => {
    const bold = /^\*\*([^*]+)\*\*$/.exec(part);
    if (bold) {
      return (
        <strong key={i} className="font-semibold text-white">
          {bold[1]}
        </strong>
      );
    }
    const link = /^\[([^\]]+)\]\(([^)]+)\)$/.exec(part);
    if (link) {
      const [, label, href] = link;
      const className =
        'font-medium text-violet-300 underline decoration-violet-500/40 underline-offset-4 hover:text-violet-200';
      if (href && href.startsWith('/')) {
        return (
          <Link key={i} to={href} className={className}>
            {label}
          </Link>
        );
      }
      return (
        <a key={i} href={href} target="_blank" rel="noopener noreferrer" className={className}>
          {label}
        </a>
      );
    }
    return <Fragment key={i}>{part}</Fragment>;
  });
  return <>{nodes}</>;
}
